
<div class="container">


      <h2 class="content-heading">
         <!--  <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
            <i class="fa fa-plus mr-5"></i>Add Lectionary Item Type
          </button> -->
            Lectionary Item Types
      </h2>


    <div class="blockX">


      <div class="table-responsive table yearDataTable" xclass="table table-striped table-vcenter table-sm">

        <div class="xrow header gridRow row">
            <div class="col-md-2">Name</div>
            <div class="col-md-7">Description</div>
            <div class="col-md-2">SubTypes</div>
            <div class="col-md-1">Actions</div>
        </div>

        <div id="scrollableTable">
          <div class="">
                    <div *ngFor="let obj of entities" class="dateRow gridRow row">
                      <div class="col-md-2">{{obj.Localized[0].Name}}</div>
                      <div class="col-md-7">{{obj.Localized[0].Description}}</div>
                      <div class="col-md-2">
                        <div *ngFor="let subType of obj.SubTypes">
                            {{subType.Localized[0].Name}}
                        </div> 
                      </div>
                          <div class="col-md-1" >

                              <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                                  <i class="fa fa-pencil"></i>
                              </button>
                    <!--           <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="delete(obj)">
                                  <i class="fa fa-times"></i>
                              </button> -->

                            </div>
                          </div>
                      </div>
                    </div>
                  </div>

              </div>


      <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

</div>




